var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_document_accident",
            title: "Individuelle Dokumente",
          },
          on: { save: _vm.saveFirmDocuments },
        },
        [
          _c("csp-desktop-info-card-element", {
            attrs: {
              "form-context": _vm.formContext,
              label: "Individuelle Dokumente",
              property: "firmDocuments",
              stacked: "",
              type: "checkboxGroup",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }